import {initElements} from "../../define/shared"
import Splide from '@splidejs/splide'

export default function initReferencesSlider() {
    initElements(".references-slider", rfSlider => {
        const splide = rfSlider.querySelector('.splide')

        if (splide) {
            let slider = new Splide(splide, {
                arrows: true,
                type: 'loop',
                autoplay: true,
                speed: 1000,
                interval: 10000,
            }).mount()

            slider.go(getRandomInt(slider.length))
        }

        function getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max))
        }
    })
}
